import { render, staticRenderFns } from "./DeliveryAdviceEdit.vue?vue&type=template&id=54e6ea32&scoped=true"
import script from "./DeliveryAdviceEdit.vue?vue&type=script&lang=js"
export * from "./DeliveryAdviceEdit.vue?vue&type=script&lang=js"
import style0 from "./DeliveryAdviceEdit.vue?vue&type=style&index=0&id=54e6ea32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e6ea32",
  null
  
)

export default component.exports